import { PhotoAgency } from './photography-agency.model';
import { CatalogPhotographyVendor } from './catalog-photography-vendor.model';
import { VendorOverrides } from './vendor-overrides.model';

export class PhotographyProvider {
  constructor(private readonly value: PhotoAgency | CatalogPhotographyVendor) {}

  get catalogVendor(): CatalogPhotographyVendor | undefined {
    return 'vendorId' in this.value ? this.value : undefined;
  }

  get agency(): PhotoAgency | undefined {
    return 'vendorId' in this.value ? undefined : this.value;
  }

  get id(): string { return this.catalogVendor?.vendorId ?? this.agency?.vendorOverrides?.catalog?.vendorId ?? this.agency?._id; }
  get title(): string { return this.catalogVendor?.name ?? this.agency?.title; }
  get thumbnailUri(): string { return this.catalogVendor?.logoImage ?? this.agency?.thumbnailUri; }
  get email(): string { return this.catalogVendor?.email ?? this.agency?.agencyEmail; }
  get phone(): string { return this.catalogVendor?.phone ?? this.agency?.agencyPhoneNumber?.number; }
  get vendorOverrides(): VendorOverrides { return this.catalogVendor?.vendorOverrides ?? this.agency?.vendorOverrides; }
  get useCustomScheduling(): boolean { return this.catalogVendor?.useCustomScheduling ?? this.agency?.useCustomScheduling ?? false; }
  get customSchedulingUrl(): string | null | undefined { return this.catalogVendor?.customSchedulingUrl ?? this.agency?.customSchedulingUrl; }

  get catalogSnapshot(): CatalogPhotographyVendor | undefined {
    if (this.catalogVendor) return this.catalogVendor;
    const vendorId = this.agency?.vendorOverrides?.catalog?.vendorId;
    if (!vendorId) return undefined;
    return {
      vendorId,
      name: this.title,
      email: this.email,
      phone: this.phone,
      logoImage: this.thumbnailUri,
      useCustomScheduling: this.useCustomScheduling,
      customSchedulingUrl: this.customSchedulingUrl,
      vendorOverrides: this.vendorOverrides,
    };
  }

  static forAppointment(appointment?: { catalogVendor?: CatalogPhotographyVendor; photoAgency?: PhotoAgency }): PhotographyProvider | undefined {
    const provider = appointment?.catalogVendor ?? appointment?.photoAgency;
    return provider ? new PhotographyProvider(provider) : undefined;
  }
}
